var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAirconditioner = function SvgAirconditioner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path873",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M15.987 20.214c2.308 0 4.19-1.881 4.19-4.189s-1.882-4.188-4.19-4.188-4.19 1.881-4.19 4.188 1.882 4.189 4.19 4.189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path875",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M15.946 1.317v10.451"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path877",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M11.123 2.169c3.16 4.875 6.568 4.82 9.66.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path879",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M15.946 30.679V20.187"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path881",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M10.944 29.759c3.201-4.793 6.746-4.793 9.838 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path883",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M30.565 15.998H20.177"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path885",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M29.741 20.997c-4.768-3.31-4.782-6.743 0-9.833"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path887",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M1.532 15.998h10.154"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path889",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M2.11 20.997c4.822-3.2 4.795-6.743 0-9.833"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path891",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "m6.644 6.563 6.306 6.304"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path893",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "m25.413 6.563-6.293 6.304"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path895",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M25.413 25.364 19.12 19.06"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path897",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "m6.712 25.364 6.307-6.304"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAirconditioner);
export default ForwardRef;